import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import CcCluster from '../../../services/models/CcCluster';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import JobActionButton from '../../Jobs/JobActionButton';
import ClusterStopForm from './ClusterStopForm';

export default ClusterStopButton;

export type ClusterStopButtonProps = ButtonProps & {
    cluster: CcCluster;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function ClusterStopButton({
    cluster,
    children,
    onSuccess,
    ...rest
}: ClusterStopButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.STOP_CLUSTER}
                    clusterId={cluster.clusterId}
                    critical={true}
                    {...rest}
                >
                    {children || 'Stop cluster'}
                </JobActionButton>
            }
            form={<ClusterStopForm cluster={cluster} onSuccess={onSuccess} />}
        />
    );
}
